import Tabs, { Tab } from '@components/atoms/ui-kit/tabs.tsx';
import UsageBo from '@pages/back-office/usage-bo.tsx';
import UsageCharts from '@pages/back-office/usage-charts.tsx';
import UsageLegacy from '@pages/back-office/usage-legacy.tsx';
import { BarChart2, Table, History } from 'lucide-react';

export enum UsageTabs {
  UsageLegacy = 'Usage Legacy',
  Tabular = 'Tabular',
  Overview = 'Overview'
}

export default function UsageBoDetails() {
  const tabs: Tab[] = [
    {
      id: 0,
      name: (
        <span className="flex items-center gap-2">
          <BarChart2 className="h-4 w-4" />
          {UsageTabs.Overview}
        </span>
      ),
      component: <UsageCharts />
    },
    {
      id: 1,
      name: (
        <span className="flex items-center gap-2">
          <Table className="h-4 w-4" />
          {UsageTabs.Tabular}
        </span>
      ),
      component: <UsageBo />
    },
    {
      id: 2,
      name: (
        <span className="flex items-center gap-2">
          <History className="h-4 w-4" />
          {UsageTabs.UsageLegacy}
        </span>
      ),
      component: <UsageLegacy />
    }
  ];

  return (
    <Tabs tabs={tabs} searchParams minHeight={'92vh'} maxHeight={'92vh'} />
  );
}
